import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import withStyles from "@material-ui/core/styles/withStyles";

import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import Sidebar from "components/Sidebar/Sidebar.jsx";

import bwillisRoutes from "routes/bwillis.jsx";
import { useAuth } from "context/AuthContext";

import sidebarBg from "assets/img/sidebar-3.jpg";
import logo from "assets/img/favicon.png";

import appStyle from "assets/jss/material-dashboard-pro-react/layouts/dashboardStyle.jsx";

function flattenRoutes(routes) {
  const flat = [];
  routes.forEach(r => {
    if (r.redirect || r.hidden) {
      flat.push(r);
    } else if (r.collapse) {
      flat.push(...flattenRoutes(r.views));
    } else if (r.component) {
      flat.push(r);
    }
  });
  return flat;
}

const switchRoutes = (
  <Switch>
    {flattenRoutes(bwillisRoutes).map((prop, key) => {
      if (prop.redirect)
        return <Redirect from={prop.path} to={prop.pathTo} key={key} />;
      return <Route exact path={prop.path} component={prop.component} key={key} />;
    })}
  </Switch>
);

var ps;

class BWillisLayoutInner extends React.Component {
  constructor(props) {
    super(props);
    this.state = { mobileOpen: false, miniActive: false };
    this.resizeFunction = this.resizeFunction.bind(this);
  }

  componentDidMount() {
    if (!this.props.auth.user && !this.props.auth.loading) {
      this.props.history.push("/bwillis/login");
      return;
    }
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.refs.mainPanel, {
        suppressScrollX: true, suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", this.resizeFunction);
  }

  componentDidUpdate(prevProps) {
    if (!this.props.auth.user && !this.props.auth.loading) {
      this.props.history.push("/bwillis/login");
    }
    if (prevProps.history.location.pathname !== prevProps.location.pathname) {
      if (this.refs.mainPanel) this.refs.mainPanel.scrollTop = 0;
      if (this.state.mobileOpen) this.setState({ mobileOpen: false });
    }
  }

  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1 && ps) ps.destroy();
    window.removeEventListener("resize", this.resizeFunction);
  }

  handleDrawerToggle = () => this.setState({ mobileOpen: !this.state.mobileOpen });

  getRoute() {
    return this.props.location.pathname !== "/bwillis/maps/full-screen";
  }

  sidebarMinimize = () => this.setState({ miniActive: !this.state.miniActive });

  resizeFunction() {
    if (window.innerWidth >= 960) this.setState({ mobileOpen: false });
  }

  render() {
    const { classes, auth, ...rest } = this.props;
    const { miniActive, mobileOpen } = this.state;

    if (auth.loading) return <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>Loading…</div>;
    if (!auth.user) return null;
    if (auth.user.role === "Student") return <Redirect to="/portal/dashboard" />;

    const userRole = auth.user.role || "";
    const visibleRoutes = bwillisRoutes.filter(r => {
      if (r.redirect || r.hidden) return false;
      if (!r.roles || r.roles.includes("*")) return true;
      return r.roles.includes(userRole);
    });

    const mainPanel = classes.mainPanel + " " + cx({
      [classes.mainPanelSidebarMini]: miniActive,
      [classes.mainPanelWithPerfectScrollbar]: navigator.platform.indexOf("Win") > -1
    });

    return (
      <div className={classes.wrapper}>
        <Sidebar
          routes={visibleRoutes}
          logoText="BW PTC"
          logo={logo}
          image={sidebarBg}
          handleDrawerToggle={this.handleDrawerToggle}
          open={mobileOpen}
          color="blue"
          bgColor="black"
          miniActive={miniActive}
          currentUser={auth.user}
          onLogout={auth.logout}
          {...rest}
        />
        <div className={mainPanel} ref="mainPanel">
          <Header
            sidebarMinimize={this.sidebarMinimize}
            miniActive={miniActive}
            routes={visibleRoutes}
            handleDrawerToggle={this.handleDrawerToggle}
            currentUser={auth.user}
            onLogout={auth.logout}
            {...rest}
          />
          {this.getRoute() ? (
            <div className={classes.content}>
              <div className={classes.container}>{switchRoutes}</div>
            </div>
          ) : (
            <div className={classes.map}>{switchRoutes}</div>
          )}
          {this.getRoute() ? <Footer fluid /> : null}
        </div>
      </div>
    );
  }
}

BWillisLayoutInner.propTypes = {
  classes: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired
};

const BWillisLayoutStyled = withStyles(appStyle)(BWillisLayoutInner);

function BWillisLayout(props) {
  const auth = useAuth();
  return <BWillisLayoutStyled {...props} auth={auth} />;
}

export default BWillisLayout;
